import { render, staticRenderFns } from "./ApuracaoContratoTabSemestral.vue?vue&type=template&id=47de641f"
import script from "./ApuracaoContratoTabSemestral.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoTabSemestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports